import {Paper as GWCPaper} from '@yandex-taxi/go-web-components'

/** @deprecated use `Paper` from '@logistics-frontend/blocks' */
export const Paper = GWCPaper
